import request from '@/utils/request'

const _Prefix = "/integralSet"

// 查询积分信息列表
export function integralList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询积分信息详细
export function getIntegral(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 查询积分设置并放缓存
export function getIntegralCache() {
    return request({
        url: _Prefix + '/query/integral',
        method: 'get'
    })
}

// 新增积分信息
export function addIntegral(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改积分信息
export function updateIntegral(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除积分信息
export function delIntegral(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}